module.exports = __webpack_public_path__ + "img/global-search-watermark.da6c3323.svg";